import { defineStore } from 'pinia'

type State = {
  accordions: Record<
    string,
    {
      currentAccordionIndex: string
    }
  >
}

export const useAccordion = defineStore('accordion', {
  state: (): State => {
    const initialState: State = {
      accordions: {},
    }

    return initialState
  },
  actions: {
    toggleIndex(itemIndex: string, accordionIndex: string) {
      if (
        itemIndex === this.accordions[accordionIndex]?.currentAccordionIndex
      ) {
        this.accordions = {
          ...this.accordions,
          [accordionIndex]: {
            currentAccordionIndex: '',
          },
        }
      } else {
        this.accordions = {
          ...this.accordions,
          [accordionIndex]: {
            currentAccordionIndex: itemIndex,
          },
        }
      }
    },
  },
})
